import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { VersionsViewService, VersionsEditorService } from '@app/services/app/versions.service';

import { AppService } from '@app/services/app/app.service';
import { AccessVersion } from '@app/models/access';
import { AppRouterService } from '@app/services/app/router.service';

import * as Objects from '@core/objects';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { FilesListItemMenuClick } from '@core/components/files/lists/files-list-item-menu-click';
import { NotificationsContextEnum } from '@core/store/models/notifications.enum';
import { VersionFeedback, ShareVersionFeedback } from '@core/models/version-feedback';
import { VersionShare, UploadVersionShare } from '@core/models/version-share.model';
import { VersionShareFeedbackMessage } from '@core/models/version-share-message.model';

import { UrlService } from '@core/services/url/url.service';
import { NotificationsService } from '@core/services/notifications/notifications.service';
import { InterfaceListenerService } from '@core/services/interface-listener/interface-listener.service';
import { VersionsService } from '@core/services/versions/versions.service';


@Component({
    selector: 'version-details-content',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class VersionsDetailsContentMainComponent implements OnInit, OnDestroy {
    protected readonly PLUGIN_SEND_FILES = 'share_transfer';
    protected readonly PLUGIN_FEEDBACK = 'share_feedback';
    protected readonly PLUGIN_APOLLO = 'apollo';

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_ERROR = 2;

    public readonly MODAL_VIEW_NONE = 0;
    public readonly MODAL_VIEW_FILES_SIGNED_ERROR = 1

    @Input() project: Objects.Request = null;
    public version: Objects.Version = null;
    public modalView: number = this.MODAL_VIEW_NONE;

    public pluginsAccess: Array<string> = [];
    public access: AccessVersion;
    public accessFeedbacks: boolean = null;
    public feedbacks: Array<VersionFeedback> = null;
    public share: any = null;
    public sharedFileIds: Array<number> = null;

    // protected uploadVersionShares: Array<UploadVersionShare> = null;
    public versionShareMessages: Array<VersionShareFeedbackMessage> = [];
    public versionShareList: Array<VersionShare> = [];
    /*
    access_version_write_comments: boolean;
    access_version_read_comments: boolean;
    access_version_change_status: boolean;
    access_version_original_name: boolean;
    access_version_upload_no_file: boolean;
    access_version_edit_labels: boolean;
     */

    public menu: Array<ThreeDotsMenuItem> = [
        {
            title: "Download File",
            key: "download",
            icon: "download",
            order: 1
        },
        {
            title: "Open Preview in New Tab",
            key: "open-preview",
            icon: "see-details",
            order: 2
        },
    ];

    protected menuSendFiles: ThreeDotsMenuItem = {
        title: "Send",
        key: "send-files",
        icon: "send-files",
        order: 3
    };
    protected menuCompare: ThreeDotsMenuItem = {
        title: "Compare",
        key: "compare",
        icon: "compare",
        order: 4
    };

    public status:number = this.STATUS_LOADING;

    protected accessSubscriptor: Subscription;
    protected versionSubscriptor: Subscription;
    protected appSubscriptor: Subscription;
    protected feedbacksSubscriptor: Subscription;
    protected shareVersionSubscriptor: Subscription;
    protected versionSharesSubscriptor: Subscription;
    protected shareMessagesSubscriptor: Subscription;

    constructor(
        private app: AppService,
        private urlSrv: UrlService,
        private editorVersionSrv: VersionsEditorService,
        private viewVersionSrv: VersionsViewService,
        private notifSrv: NotificationsService,
        private appRouter: AppRouterService,
        private iListener: InterfaceListenerService,
        private coreVersionsService: VersionsService
    ) { }

    ngOnInit() {


        this.versionSubscriptor = this.viewVersionSrv.selectVersion().subscribe((version: Objects.Version)=> {
            this.version = version;
            this.initView();
        });

        this.accessSubscriptor = this.editorVersionSrv.selectAccessAll().subscribe((access: AccessVersion)=> this.access = access);

        this.appSubscriptor = this.app.getSession().subscribe( (session: any) => {
            this.pluginsAccess = session.options.plugins;
            this.updateMenu(this.menuSendFiles,this.checkPluginAccess(this.PLUGIN_SEND_FILES))
            this.updateMenu(this.menuCompare,this.checkPluginAccess(this.PLUGIN_APOLLO));
            this.accessFeedbacks = this.checkPluginAccess(this.PLUGIN_FEEDBACK);
            if(this.accessFeedbacks)
                this.initFeedbacks();
            else 
                this.initView();
        });

        this.shareVersionSubscriptor = this.viewVersionSrv.selectShareFeedback().subscribe((shareVersionFeedback: ShareVersionFeedback) => {
            // here comes the shareVersionFeedback with properties:
            if(shareVersionFeedback != null){
                this.share = shareVersionFeedback.share;
                if( this.share.entry &&
                    this.share.entry.share &&
                    this.share.entry.share.properties )
                {
                    let filesProp = this.share.entry.share.properties.filter((p:any) => p.key == 'files');
                    this.sharedFileIds = filesProp.length > 0 ? (filesProp[0]).value : [];
                }
            }
        });

    }

    initView(){
        if(this.version == null)
            return;

        if ((this.accessFeedbacks != null && !this.accessFeedbacks) || 
            (this.accessFeedbacks && (this.feedbacks != null || this.versionShareList.length > 0 ) )
        ){
            this.status = this.STATUS_DONE;

        }
    }

    ngOnDestroy() {
        this.versionSubscriptor.unsubscribe();
        this.accessSubscriptor.unsubscribe();
        this.appSubscriptor.unsubscribe();
        if(this.feedbacksSubscriptor){
            this.feedbacksSubscriptor.unsubscribe();
        }
        this.shareVersionSubscriptor.unsubscribe();
        if(this.versionSharesSubscriptor)
            this.versionSharesSubscriptor.unsubscribe();
        if(this.shareMessagesSubscriptor)
            this.shareMessagesSubscriptor.unsubscribe();
    }

    onMenuClick(menu: FilesListItemMenuClick) {
        switch(menu.key) {
            case "download-comments": 
                this.notifSrv.addNotification(NotificationsContextEnum.EVENT_FILE_ANNOTATIONS_START, {id: this.project.id, details: { url: "/versions/"+this.version.id+"/feedbacks", file: menu.file}});
                break;
            case "download":
                console.debug(" download click on file ", menu.file);
                window.location.href = this.urlSrv.build('/files/'+menu.file.id);
                break;
            case "download-signatures":
                console.debug(" download-signatures click on file ", menu.file);
                // start notification to download compressed project files in zip
                this.coreVersionsService.getFileWithSignatures$(this.version,menu.file)
                    .subscribe({
                        next: (fileSigned: Objects.File) => {
                            window.location.href = this.urlSrv.build('/files/'+fileSigned.id);
                        },
                        error: (error) => {
                            this.modalView = this.MODAL_VIEW_FILES_SIGNED_ERROR;
                        }
                    })
                break;
            case "open-preview":
                console.debug(" open-preview click on file ", menu.file);
                window.open(window.location.href +'/files/'+menu.file.id, '_blank');
                break;
            case "send-files":
                if (this.checkPluginAccess(this.PLUGIN_SEND_FILES))
                    this.appRouter.navigate('/p/transfer/'+this.project.id, { queryParams: { file: +menu.file.id, version: this.version.id} });
                break;
            case "compare":
                if (this.checkPluginAccess(this.PLUGIN_APOLLO))
                    this.appRouter.navigate('/p/apollo/request/'+this.project.id);//, { queryParams: { reference: +menu.file.id} });
                break;
        }
    }

    public onFeedbackDone(feedback: VersionFeedback) : void {
        if(this.accessFeedbacks){
            this.iListener.triggerFeedbackDone(feedback.version);
            this.viewVersionSrv.loadFeedbacks();
        }
        else 
            this.initView();
    }

    public onShareVersionStatusUpdated(share: VersionShare){
        this.iListener.triggerFeedbackDone(this.version);
    }

    protected checkPluginAccess(plugin: string){
        return this.pluginsAccess.some((pa) => pa == plugin);
    }

    // this function check either remove or add item. based on subscribed events
    protected updateMenu(item: ThreeDotsMenuItem, addItem:boolean = true) {
        this.menu = this.menu.filter((i: ThreeDotsMenuItem) => item.key != i.key);
        if(addItem){
            this.menu.push(item);
        }
    }

    protected initFeedbacks(){
        this.feedbacksSubscriptor = this.viewVersionSrv.selectFeedbacks().subscribe((feedbacks: Array<VersionFeedback>) => {
            this.feedbacks = feedbacks;

            this.initView();
        })

        this.versionSharesSubscriptor = this.viewVersionSrv.selectVersionShares().subscribe((allShares:VersionShare[]) => {
            if(allShares != null){
                this.versionShareList = allShares;
                this.initView();
            }
        });

        this.shareMessagesSubscriptor = this.viewVersionSrv.selectVersionShareMessages().subscribe((shareMessages: Array<VersionShareFeedbackMessage>) => {
            // Here we get the messages generated based on the already completed or closed version shares (bubbles)
            if (shareMessages != null ){
                // Compare each message's custom ID (UUID) to ensure not equality to update new ones
                if (this.versionShareMessages != null && 
                    (this.versionShareMessages.length === 0 || 
                        !this.versionShareMessages.every((prevMsg, index) => prevMsg.uuid === shareMessages[index]?.uuid))) {
                    
                    this.versionShareMessages = shareMessages;
                }
            }
        });
    }

    public dismmisError(){
        this.modalView = this.MODAL_VIEW_NONE;
    }

}
